var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "my-modal",
      attrs: {
        id: "modal-subjects",
        title: "Participantes",
        "no-close-on-backdrop": "",
        "ok-title": "Actualizar",
        "ok-only": "",
        size: "lg"
      },
      on: { ok: _vm.handleOk, cancel: _vm.cancelAction }
    },
    [
      _c(
        "b-overlay",
        { staticClass: "container-subjects", attrs: { show: _vm.loading } },
        [
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("h4", [_vm._v("Destinatarios")])
            ]),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                !_vm.isSiss
                  ? _c("SelectSubject", {
                      attrs: { docTypeSelected: _vm.documentTypeSelected },
                      on: { "add-subject": _vm.addSubject }
                    })
                  : _vm._e(),
                _vm.isSiss
                  ? _c("SelectSubjectSISS", {
                      attrs: {
                        docTypeSelected: _vm.documentTypeSelected,
                        "is-doc-digital": _vm.isDocDigital
                      },
                      on: {
                        "add-subject": _vm.addSubject,
                        "clear-sanitaries": _vm.clearSanitaries,
                        "clear-doc-digital": _vm.clearDocDigital
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("TableSubjects", {
                  attrs: { subjects: _vm.subjects },
                  model: {
                    value: _vm.subjectsSelected,
                    callback: function($$v) {
                      _vm.subjectsSelected = $$v
                    },
                    expression: "subjectsSelected"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "col-md-1" }),
          _c("div", { staticClass: "row mb-3" }, [
            _c("div", { staticClass: "col-md-12" }, [
              _c("h4", [_vm._v("Con copia a")])
            ]),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                !_vm.isSiss
                  ? _c("SelectCopy", { on: { "add-copy": _vm.addCopy } })
                  : _vm._e(),
                _vm.isSiss
                  ? _c("SelectCopySISS", {
                      attrs: { "is-doc-digital": _vm.isDocDigital },
                      on: {
                        "add-copy": _vm.addCopy,
                        "clear-sanitaries": _vm.clearSanitaries,
                        "clear-copies-doc-digital": _vm.clearCopiesDocDigital
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("TableCopies", {
                  attrs: { copies: _vm.copies },
                  model: {
                    value: _vm.copiesSelected,
                    callback: function($$v) {
                      _vm.copiesSelected = $$v
                    },
                    expression: "copiesSelected"
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }